document.addEventListener('DOMContentLoaded', function () {
    const mobileMenuButtonOpen = document.querySelector(".mobile-menu__open");
    const mobileMenuButtonClose = document.querySelector(".mobile-menu__close");
    const mobileMenuButtonBg = document.querySelector(".mobile-menu__bg");
    const submenuItems = document.querySelectorAll(".mobile-menu__items-single .has-subitems");

    mobileMenuButtonOpen.addEventListener("click", showMenu);
    mobileMenuButtonClose.addEventListener("click", hideMenu);
    mobileMenuButtonBg.addEventListener("click", hideMenu);
    if(submenuItems){
        submenuItems.forEach(submenuItem => submenuItem.addEventListener("click", toggleSubmenu));
    }
});

const showMenu = () => {
    const mobileMenu = document.querySelector(".mobile-menu");
    mobileMenu.classList.add("visible");
    document.body.classList.add("no-focus");
}

const hideMenu = () => {
    const mobileMenu = document.querySelector(".mobile-menu");
    mobileMenu.classList.remove("visible");
    document.body.classList.remove("no-focus");
}

function toggleSubmenu(e) {
    e.preventDefault();
    this.parentNode.classList.toggle("visible");

}